import { Page, AdminTransactionType } from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const getTransactions = (status: string | null, page?: number) =>
  APIService.get<null, Page<AdminTransactionType>>(
    `/admin/transactions?statuses=${status && status !== "all" ? status : ""}&page=${page}`,
  )
const getTransaction = (id: string) =>
  APIService.get<null, AdminTransactionType>(`/admin/transactions/${id}`)
const changeStatus = (id: string, status: string) =>
  APIService.post<null, AdminTransactionType>(`/admin/transactions/${id}/status?status=${status}`)
const addInvoiceUrl = (id: string, url: string) =>
  APIService.post<null, AdminTransactionType>(`/admin/transactions/${id}/invoice`, {
    url: url,
  })

export const AdminTransactionsService = {
  getTransactions,
  getTransaction,
  changeStatus,
  addInvoiceUrl,
}
